function camelToDashes(str) {
    return str.replace(/([A-Z])/g, '-$1').replace(/^-/, '')
        .toLowerCase();
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function dashesToCamel(str) {
    return str.replace(/-([a-z])/g, g => g[1].toUpperCase());
}

/**
 * Return the specified value or an empty object if falsy
 * @param {object} val - value to check
 * @param {object} def - default value to return if val is falsy
 * @returns val or def ('' if undefined)
 */
function getValueOrDefault(val, def = '') {
    return val || def;
}

function mergeCustomizer(objValue, srcValue) {
    if (Array.isArray(srcValue)) {
        return srcValue;
    }
    return undefined;
}

export {
    camelToDashes,
    capitalizeFirstLetter,
    dashesToCamel,
    getValueOrDefault,
    mergeCustomizer,
};



// WEBPACK FOOTER //
// ../loader-base/src/helpers/util.js